import { useEffect, useState } from 'react'
import { BarBlock as BarBlockType } from '../../types/panel'

interface Props { block: BarBlockType }

export default function BarBlock({ block }: Props) {
  const [grow, setGrow] = useState(false)
  useEffect(() => {
    const t = setTimeout(() => setGrow(true), 80)
    return () => clearTimeout(t)
  }, [])

  const items = Array.isArray(block.items) ? block.items : []
  return (
    <div className="k-block">
      <h4 className="k-block__title">{block.title}</h4>
      {block.subtitle && <div className="k-block__sub">{block.subtitle}</div>}
      <div className="k-hbars">
        {items.map((item, i) => {
          const pct = Math.min(100, (item.value / (item.max || 1)) * 100)
          const toneClass = item.tone === 'danger' ? ' is-crit' : item.tone === 'warn' ? ' is-warn' : ''
          return (
            <div className={'k-hbar' + toneClass} key={i}>
              <div className="k-hbar__label">{item.label}</div>
              <div className="k-hbar__track">
                <div className="k-hbar__fill" style={{ width: grow ? `${pct}%` : '0%' }}></div>
              </div>
              <div className="k-hbar__val">{item.value.toLocaleString('de-DE')}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
